import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-management',
  templateUrl: './management.component.html',
  styleUrls: ['./management.component.css']
})
export class ManagementComponent implements OnInit {

  showIndustryList = 'indList';
  route:string;
  roleView = 'list';
  showSubRegionEdit = [];
  groupView = 'list';
  attachDistrictView = 'list';
  public state: string = environment.state;
  officeTypeView = 'list';

  attachDistrictLoader = false;

  roleListLoader = false;
  roleList = [];
  attachDistrictList = [];

  officerTypeUpdateError = '';
  errorOfficerUpdate = false;

  allIndustriesDetails = [];
  showTehsilEdit = [];
  showofficerTypeEdit = [];
  subRegionView = 'list';
  subRegionListAdmin = [];
  showOfficeEdit = [];
  showGroupEdit = [];
  groupList = [];
  groupLoader = false;
  showDistrictEdit = [];
  industryListLoader = false;
  roleId = 0;
  searchField = [];
  formEditDistrictNameError = '';
  formEditDistrictCodeError = '';
  tehsilInternalView = 'list';
  errorEditDistrict = false;
  tehsilList = [];
  tehsilLoader = false;
  newApiKey = '';
  formEditOfficeNameError = '';
  errorEditOfficeName = false;
  officerList = [];
  officeListViewLoader = false;
  officeList = [];
  showOfficeTypeEdit = [];
  districtList = [];
  officerTypeListLoader = false;
  officerTypeUpdate = [];
  userToUpdate = [];
  vendorUser = [];
  officerView = 'list';
  vendorEdit = [];
  userDetails = [];
  formErrorName = '';
  formErrorEmail = '';
  officeTypeInput = [];
  formErrorContact = '';
  formErrorRegion = '';
  error = false;

  vendorListLoader = false;
  officeListLoader = false;

  attachOffice = '';
  attachGroupList = [];
  attachGroupName = '';
  attachOfficetypeError = '';
  attachError = false;
  attachGroupError = '';
  attachDistrictError = '';

  officeTypeOfficeName = '';
  officeType = [];
  officeTypeError = false;
  districtInternalView = 'list';
  officeTypeNameError = '';
  officeTypeOfficeNameError = '';
  officeTypeCount = 0;

  districtCode = '';
  districtName = '';
  formDistrictNameError = '';
  formDistrictCodeError = '';
  errorDistrict = false;

  officeTypeList = [];

  groupType = 'CEMS';
  groupCount = 0;
  groupInput = [];
  groupName = [];
  roleOfficerOcmmsList = [];
  groupError = false;
  groupTypeError = '';
  groupNameError = '';
  groupOfficeType = '';
  districtLoader = false;
  groupOfficetypeError = '';


  subRegionOffice = '';
  subRegionGroupList = [];
  subRegionError = false;
  subRegionGroupType = 'CEMS';
  subRegionGroupName = '';
  subRegionOfficetypeError = '';
  subRegionGroupTypeError = '';
  subRegionGroupError = '';
  subRegionCount = 0;
  subRegionInput = [];
  subRegionNameError = '';
  subRegionName = [];

  editEnable  = false;
  showEdit = [];

  tehsilDistrict = '';
  TehsilCount = 0;
  tehsilInput = [];
  tehsilName = [];
  tehsilError = false;
  tehsilNameError = '';
  tehsilDistrictError = '';

  officerType = '';
  officerTypeError = '';
  errorOfficer = false;

  officeName = '';
  errorOfficeName = false;
  subRegionLoader = false;
  formofficeNameError = '';

  dropdownList = [];
  selectedDistrict = [];
  dropdownSettings = {};
  RoleSubRegiondropdownSettings = {};

  officerTypeList = [];
  officeListView = [];
  subRegionList = [];
  roleSubRegionList = [];

  roleOffice = '';
  roleOfficetypeError = '';
  roleGroupName = '';
  roleGroupError = '';
  roleName = '';
  description = '';
  scrutinyRight = 'yes';
  scrutinyRightError = '';

  assignedDays = 1;
  assignedDaysError = '';

  grantRegular = 'yes';
  grantRegularError = '';

  canInspection = 'no';
  canInspectionError = '';

  grantTrial = 'yes';
  grantTrialError = '';
  returnRight = 'yes';
  returnRightError = '';
  roleNameError = '';
  descriptionError = '';
  roleOfficerType = '';
  roleOfficerTypeError = '';
  roleLinkOfficer = '';
  roleLinkOfficerError = '';
  roleStatus = '';
  roleStatusError = '';
  roleSubRegion = '';
  roleSubRegionError = '';
  roleError = false;
  roleOfficerList = [];
  userData:any = [];
  vendorList = [];

  officeAdminView = 'list';
  headingTitle = 'Unit Station Detail Management';

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));

    if(this.userData){
      if(this.userData['access_level'] != 'admin' && this.userData['user_profile_id'] != 'HSPCBCEMS'){
        // this.router.navigate(['dashboard']);
      }
    }

    this.userDetails['name'] = '';
    this.userDetails['email'] = '';
    this.userDetails['contact'] = '';
    this.userDetails['region'] = '';
    this.getDisabledIndustryList();
    this.getOfficerList();
    this.officeTypeInput[this.officeTypeCount] = true;
    this.officeType[this.officeTypeCount] = '';

    this.tehsilInput[this.TehsilCount] = true;
    this.tehsilName[this.TehsilCount] = '';

    this.groupInput[this.groupCount] = true;
    this.groupName[this.groupCount] = '';

    this.subRegionInput[this.subRegionCount] = true;
    this.subRegionName[this.subRegionCount] = '';

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'district_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true
    };

    this.RoleSubRegiondropdownSettings = {
      singleSelection: false,
      idField: 'id',
      textField: 'sub_region_name',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      allowSearchFilter: true
    };

  }

  onItemSelect(item: any) {
    console.log(item);
  }
  onSelectAll(items: any) {
    console.log(items);
  }

  addMoreOfficeType(){
    this.officeTypeCount = this.officeTypeCount + 1;

    this.officeType[this.officeTypeCount] = '';
    this.officeTypeInput[this.officeTypeCount] = true;
  }

  addMoreTehsil(){
    this.TehsilCount = this.TehsilCount + 1;

    this.tehsilName[this.TehsilCount] = '';
    this.tehsilInput[this.TehsilCount] = true;
  }

  addMoreGroup(){
    this.groupCount = this.groupCount + 1;

    this.groupName[this.groupCount] = '';
    this.groupInput[this.groupCount] = true;
  }

  addMoreSubRegion(){
    this.subRegionCount = this.subRegionCount + 1;

    this.subRegionName[this.subRegionCount] = '';
    this.subRegionInput[this.subRegionCount] = true;
  }

  removeOfficeType(typeNumber){
    // this.officeType[typeNumber] = false;
    // alert(this.officeType.indexOf(typeNumber));
    this.officeType[typeNumber] = null ;
    this.officeTypeInput[typeNumber] = false;
  }

  removeTehsil(typeNumber){
    this.tehsilName[typeNumber] = null ;
    this.tehsilInput[typeNumber] = false;
  }

  removeGroup(typeNumber){
    this.groupName[typeNumber] = null ;
    this.groupInput[typeNumber] = false;
  }

  removeSubRegion(typeNumber){
    this.subRegionName[typeNumber] = null ;
    this.subRegionInput[typeNumber] = false;
  }

  saveOfficeType(requestType){

    this.officeTypeError = false;

    console.log(this.officeTypeOfficeName);

    if(this.officeTypeOfficeName){
      this.officeTypeOfficeNameError = '';
    }else{
      this.officeTypeOfficeNameError = 'Please select office';
      this.officeTypeError = true;
    }

    this.officeTypeNameError = '';

    for(var type in this.officeType){
      if(this.officeType[type] != null && this.officeType[type].trim() == ''){
        this.officeTypeNameError = 'Please enter all type';
        this.officeTypeError = true;
      }
    }

    if(!this.officeTypeError){

      this.route  = 'add-office-type';
      const token = localStorage.getItem('userToken');
      let data = {
        'officeId':this.officeTypeOfficeName,
        'officeType':this.officeType,
        'type': requestType
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        if(response.status == 200){

          this.officeTypeView = 'list';
          this.officeTypeOfficeName = '';
          this.officeType = [];
          this.officeTypeError = false;
          this.officeTypeNameError = '';
          this.officeTypeOfficeNameError = '';
          this.officeTypeCount = 0;

          this.officeTypeInput[this.officeTypeCount] = true;
          this.officeType[this.officeTypeCount] = '';
          this.officeTypeView = 'list';
          this.showOfficeTypeEdit = [];

          this.getOfficeTypeOfficeWise();
          Swal('Success', 'Office Type Added Successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });
    }
  }

  changeOfficeTypeInternalView(type){
    this.officeTypeOfficeName = '';
    this.officeTypeCount = 0;
    this.showOfficeTypeEdit = [];
    this.officeType = [];
    this.officeTypeError = false;
    this.officeTypeInput[0] = true;

    if(type == 'add'){
      this.officeTypeView = 'add';
    }else{
      this.officeTypeView = 'list';
    }

  }
  setOfficeViewDetails(type){
    this.officeAdminView = 'add';
    this.errorOfficeName = false;
    this.showOfficeEdit = [];
  }

  setRoleView(type){
    this.roleView = type;
    this.resetRoleForm();
    this.getOfficeTypeList();
    this.getDistrictList();
    this.getOfficerTypeList();
    this.gerOcemmsOfficerList();

  }

  setAttachDistrictViewView(type){
    this.attachDistrictView = type;
    this.resetAttachDistrict();
    this.getOfficeTypeList();
    this.getDistrictList();
  }

  resetAttachDistrict(){
    this.attachOffice = '';
    this.selectedDistrict = [];
    this.dropdownList = [];
    this.attachGroupList = [];
    this.attachGroupName = '';
    this.attachOfficetypeError = '';
    this.attachError = false;
    this.attachGroupError = '';
    this.attachDistrictError = '';
  }

  saveTehsil(requestType){

    this.tehsilError = false;

    if(this.tehsilDistrict){
      this.tehsilDistrictError = '';
    }else{
      this.tehsilDistrictError = 'Please select district';
      this.tehsilError = true;
    }

    this.tehsilNameError = '';
    for(var type in this.tehsilName){
      if(this.tehsilName[type] != null && this.tehsilName[type].trim() == ''){
        this.tehsilNameError = 'Please enter all tehsil name';
        this.tehsilError = true;
      }
    }

    if(!this.tehsilError){

      this.route  = 'add-tehsil';
      const token = localStorage.getItem('userToken');
      let data = {
        'districtId':this.tehsilDistrict,
        'tehsilName':this.tehsilName,
        'type':requestType
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        if(response.status == 200){

          this.tehsilInternalView = 'list';
          this.tehsilDistrict = '';
          this.TehsilCount = 0;
          this.tehsilInput = [];
          this.tehsilName = [];
          this.tehsilError = false;
          this.tehsilNameError = '';
          this.tehsilDistrictError = '';
          this.tehsilInput[this.TehsilCount] = true;
          this.tehsilName[this.TehsilCount] = '';

          this.getTehsilList();
          Swal('Success', 'Tehsil Added Successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });
    }

  }

  saveGroup(Actiontype){

    this.groupError = false;

    if(this.groupOfficeType){
      this.groupOfficetypeError = '';
    }else{
      this.groupOfficetypeError = 'Please select office type';
      this.groupError = true;
    }

    if(this.groupType.trim()){
      this.groupTypeError = '';
    }else{
      this.groupTypeError = 'Please enter group type';
      this.groupError = true;
    }

    this.groupNameError = '';
    for(var type in this.groupName){
      if(this.groupName[type] != null && this.groupName[type].trim() == ''){
        this.groupNameError = 'Please enter all group name';
        this.groupError = true;
      }
    }

    if(!this.groupError){

      this.route  = 'add-groups';
      const token = localStorage.getItem('userToken');
      let data = {
        'officeTypeId':this.groupOfficeType,
        'groupType':this.groupType.trim(),
        'groupName':this.groupName,
        'type':Actiontype
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        if(response.status == 200){

          this.groupOfficeType = '';
          this.groupType = 'CEMS';
          this.groupCount = 0;
          this.groupInput = [];
          this.groupName = [];
          this.groupError = false;
          this.groupTypeError = '';
          this.groupNameError = '';
          this.groupOfficeType = '';
          this.groupOfficetypeError = '';
          this.groupInput[this.groupCount] = true;
          this.groupName[this.groupCount] = '';

          this.groupView = 'list';
          this.getGroupList();
          Swal('Success', 'Group Added Successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });

    }

  }

  saveSubRegion(requestType){

    this.subRegionError = false;

    if(this.subRegionOffice){
      this.subRegionOfficetypeError = '';
    }else{
      this.subRegionOfficetypeError = 'Please select office type';
      this.subRegionError = true;
    }

    if(this.subRegionGroupType){
      this.subRegionGroupTypeError = '';
    }else{
      this.subRegionGroupTypeError = 'Please enter group type';
      this.subRegionError = true;
    }

    if(this.subRegionGroupName){
      this.subRegionGroupError = '';
    }else{
      this.subRegionGroupError = 'Please enter group type';
      this.subRegionError = true;
    }

    this.subRegionNameError = '';
    for(var type in this.subRegionName){
      if(this.subRegionName[type] != null && this.subRegionName[type].trim() == ''){
        this.subRegionNameError = 'Please enter all sub region name';
        this.subRegionError = true;
      }
    }

    if(!this.subRegionError){

      this.route  = 'add-sub-region';
      const token = localStorage.getItem('userToken');
      let data = {
        'officeTypeId':this.subRegionOffice,
        'groupType':this.subRegionGroupType,
        'groupId':this.subRegionGroupName,
        'subRegion':this.subRegionName,
        'type': requestType
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        if(response.status == 200){

          this.subRegionOffice = '';
          this.subRegionGroupList = [];
          this.subRegionError = false;
          this.subRegionGroupType = 'CEMS';
          this.subRegionGroupName = '';
          this.subRegionOfficetypeError = '';
          this.subRegionGroupTypeError = '';
          this.subRegionGroupError = '';
          this.subRegionCount = 0;
          this.subRegionInput = [];
          this.subRegionNameError = '';
          this.subRegionName = [];
          this.subRegionView= 'list';
          this.subRegionInput[this.subRegionCount] = true;
          this.subRegionName[this.subRegionCount] = '';

          this.gerSubRegionList();

          Swal('Success', 'Sub Region Added Successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });

    }

  }

  saveDistrict(){

    this.errorDistrict = false;

    if(this.districtCode.trim()){
      this.formDistrictCodeError = '';
    }else{
      this.formDistrictCodeError = 'Please enter district code';
      this.errorDistrict = true;
    }

    if(this.districtName.trim()){
      this.formDistrictNameError = '';
    }else{
      this.formDistrictNameError = 'Please enter district name';
      this.errorDistrict = true;
    }

    if(!this.errorDistrict){

      this.route  = 'add-district';
      const token = localStorage.getItem('userToken');
      let data = {
        'districtCode':this.districtCode.trim(),
        'districtName':this.districtName.trim()
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }

        if(response.status == 200){
          this.districtInternalView = 'list';
          this.districtCode = '';
          this.districtName = '';
          this.formDistrictNameError = '';
          this.formDistrictCodeError = '';
          this.errorDistrict = false;
          this.getDistrictList();

          Swal('Success', 'District Added Successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });

    }

  }


  setOfficerToUpdate(userData){

    this.userToUpdate = [];

    this.userToUpdate['ind_'+userData['id']] = [];

    // this.editEnable  = false;
    this.showEdit = [];

    this.userToUpdate['ind_'+userData['id']]['name'] = userData['name'];
    this.userToUpdate['ind_'+userData['id']]['contact_number'] = userData['contact_number'];
    this.userToUpdate['ind_'+userData['id']]['region_name'] = userData['region_name'];
    this.userToUpdate['ind_'+userData['id']]['email'] = userData['email'];
    this.userToUpdate['ind_'+userData['id']]['user_id'] = userData['id'];

    // this.editEnable  = true;
    this.showEdit['ind_'+userData['id']] = true;

  }

    deleteOfficer(userData){
      const data = {
        id: userData.id
      };
      this.route  = 'soft-delete-officer';
          const token = localStorage.getItem('userToken');
          this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.getOfficerList();
        Swal('Success', 'Officer Deleted Successfully', 'success');
      }

    });
  }

  setOfficerTypeToUpdate(officerType){

    console.log('officerType');
    console.log(officerType);
    this.officerTypeUpdate = [];
    this.officerTypeUpdate['type_'+officerType['id']] = [];

    this.showofficerTypeEdit = [];
    this.officerTypeUpdate['type_'+officerType['id']]['officer_type'] = officerType['officer_type'];
    this.showofficerTypeEdit['type_'+officerType['id']] = true;

  }

  setOfficeToUpdate(officeDetail){

    this.showOfficeEdit = [];
    this.errorEditOfficeName = false;
    this.showOfficeEdit['office_'+officeDetail['id']] = [];
    this.showOfficeEdit['status_'+officeDetail['id']] = true;
    this.showOfficeEdit['office_'+officeDetail['id']]['office_name'] = officeDetail['office_name'];
  }

  setDistrictToUpdate(district){

    this.formEditDistrictNameError = '';
    this.formEditDistrictCodeError = '';
    this.errorEditDistrict = false;

    this.showDistrictEdit = [];
    this.showDistrictEdit['district_'+district['id']] = [];
    this.showDistrictEdit['status_'+district['id']] = true;
    this.showDistrictEdit['district_'+district['id']]['district_name'] = district['district_name'];
    this.showDistrictEdit['district_'+district['id']]['district_code'] = district['district_code'];
  }

  cancelUpdateDistrict(){
    this.showDistrictEdit = [];
    this.districtInternalView = 'list';
  }

  setOfficeTypeToUpdate(officeTypeDetail){

    this.showOfficeTypeEdit = [];
    this.showOfficeTypeEdit['type_'+officeTypeDetail['id']]  = [];
    this.showOfficeTypeEdit['typeStatus_'+officeTypeDetail['id']]  = true;

    this.route  = 'get-office-type-list';
    const token = localStorage.getItem('userToken');


    let data = {
      'office_id': officeTypeDetail['id']
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){

        this.showOfficeTypeEdit['type_'+officeTypeDetail['id']]['details'] = response.data;

        this.officeTypeOfficeName = officeTypeDetail['id'];
        this.officeTypeCount = response.data.length - 1;

        for(let types in response.data) {
          this.officeType[types] = response.data[types]['office_type'];
          this.officeTypeInput[types] = true;
        }

        console.log(this.officeTypeOfficeName, this.officeTypeCount, this.officeType);

        this.officeTypeView = 'edit';
      }

    });
  }

  setTehsilToUpdate(tehsilDetail){


    this.setTehsilValue('edit');

    this.showTehsilEdit = [];
    this.showTehsilEdit['type_'+tehsilDetail['id']]  = [];
    this.showTehsilEdit['typeStatus_'+tehsilDetail['id']]  = true;

    this.route  = 'get-tehsil-wise-list';
    const token = localStorage.getItem('userToken');


    let data = {
      'district_id': tehsilDetail['district_id']
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){

        this.tehsilDistrict = tehsilDetail['district_id'];
        this.TehsilCount = response.data.length - 1;
        for(let tehsil in response.data) {
          this.tehsilName[tehsil] = response.data[tehsil]['tehsil_name'];
          this.tehsilInput[tehsil] = true;
        }

        this.tehsilInternalView = 'edit';
      }

    });
  }

  setGroupToUpdate(groupDetail){


    this.setGroupView('edit');

    this.showGroupEdit = [];
    this.showGroupEdit['group_'+groupDetail['id']]  = [];
    this.showGroupEdit['groupStatus_'+groupDetail['id']]  = true;

    this.route  = 'get-group-list';
    const token = localStorage.getItem('userToken');


    let data = {
      'office-type-id': groupDetail['office_type_id']
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){

        this.groupOfficeType = groupDetail['office_type_id'];
        this.groupType = 'CEMS';
        this.groupCount = response.data.length - 1;

        for(let group in response.data) {
          this.groupName[group] = response.data[group]['group_name'];
          this.groupInput[group] = true;
        }
        this.groupView = 'edit';
      }

    });
  }

  setSubRegionToUpdate(subRegionDetail){

    this.setGroupView('edit');

    this.showSubRegionEdit = [];
    this.showSubRegionEdit['subRegiono_'+subRegionDetail['id']]  = [];
    this.showSubRegionEdit['subRegionStatus_'+subRegionDetail['id']]  = true;

    this.subRegionOffice = subRegionDetail['office_type_id'];
    this.getGroupName();

    this.route  = 'get-sub-region-list';
    const token = localStorage.getItem('userToken');


    let data = {
      'office-type-id': subRegionDetail['office_type_id'],
      'group-id': subRegionDetail['group_id']
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){

        this.subRegionGroupName = subRegionDetail['group_id'];
        this.subRegionGroupType = 'CEMS';
        this.subRegionCount = response.data.length - 1;

        for(let subregion in response.data) {
          this.subRegionName[subregion] = response.data[subregion]['sub_region_name'];
          this.subRegionInput[subregion] = true;
        }
        this.subRegionView = 'edit';
      }

    });
  }

  setTehsilValue(type){

    if(type == 'add'){
      this.tehsilInternalView = 'add';
      this.tehsilInput = [];
      this.tehsilName = [];
      this.TehsilCount = 1;
      this.tehsilInput[this.TehsilCount] = true;
      this.tehsilName[this.TehsilCount] = '';
      this.tehsilDistrict = '';

    }

    this.tehsilError = false;
    this.tehsilNameError = '';
    this.tehsilDistrictError = '';
  }

  setGroupView(type){

    if(type == 'add'){
      this.groupView = 'add';
      this.groupInput = [];
      this.groupName = [];
      this.groupCount = 1;
      this.groupInput[this.groupCount] = true;
      this.groupName[this.groupCount] = '';
      this.groupType = 'CEMS';
      this.groupOfficeType = '';
    }

    this.groupError = false;
    this.groupOfficetypeError = '';
    this.groupNameError = '';
    this.groupTypeError = '';
  }

  setSubRegionView(type){

    if(type == 'add'){
      this.subRegionView = 'add';
      this.subRegionInput = [];
      this.subRegionName = [];
      this.subRegionCount = 1;
      this.subRegionInput[this.subRegionCount] = true;
      this.subRegionName[this.subRegionCount] = '';
      // this.subRegionType = 'CEMS';
      // this.subRegionOfficeType = '';
    }

    this.subRegionError = false;
    this.subRegionOfficetypeError = '';
    this.subRegionGroupTypeError = '';
    this.subRegionGroupError = '';
    this.subRegionNameError = '';
  }

  setVendorToUpdate(vendorData){

    this.vendorUser = [];
    this.vendorUser['vendor_'+vendorData['id']] = [];

    // this.editEnable  = false;
    this.vendorEdit = [];

    this.vendorUser['vendor_'+vendorData['id']]['vendor_name'] = vendorData['vendor_name'];
    this.vendorUser['vendor_'+vendorData['id']]['vendor_short_name'] = vendorData['vendor_short_name'];
    this.vendorUser['vendor_'+vendorData['id']]['user_profile_id'] = vendorData['user_profile_id'];
    this.vendorUser['vendor_'+vendorData['id']]['real_user_profile_id'] = vendorData['user_profile_id'];
    this.vendorUser['vendor_'+vendorData['id']]['id'] = vendorData['id'];

    // this.editEnable  = true;
    this.vendorEdit['vendor_'+vendorData['id']] = true;
  }

  cancelUpdate(){

    this.userToUpdate = [];
    this.showEdit = [];

  }
  cancelVendorUpdate(){

    this.vendorUser = [];
    this.vendorEdit = [];

  }

  updateOfficer(){

    this.route  = 'update-officer-user';
    const token = localStorage.getItem('userToken');
    let data = {};
    for(let industry in this.userToUpdate) {
      data = {
        'name':this.userToUpdate[industry]['name'],
        'contact':this.userToUpdate[industry]['contact_number'],
        'user_id':this.userToUpdate[industry]['user_id'],
        'region_name':this.userToUpdate[industry]['region_name'],
        'email':this.userToUpdate[industry]['email']
      }
    };

    if(!data['name'].trim() || !data['contact'].trim() || !data['region_name'].trim() || !data['email'].trim()){
      Swal('Error...', 'All Fields are required', 'error');
      return;
    }

    if(data['contact'].length < 10){
      Swal('Error...', 'Contact number should be min of 10 digit', 'error');
      return;
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.getOfficerTypeList();
        this.userToUpdate = [];
        this.showEdit = [];
        Swal('Success', 'Officer Updated Successfully', 'success');
      }else{
        Swal('Oops...', 'Something went wrong!', 'error');
      }
    });

  }

  updateVendorDetail(){

    this.route  = 'update-vendor-detail';
    const token = localStorage.getItem('userToken');
    let data = {};
    for(let vendor in this.vendorUser) {
      data = {
        'id':this.vendorUser[vendor]['id'],
        'vendor_name':this.vendorUser[vendor]['vendor_name'],
        'vendor_short_name':this.vendorUser[vendor]['vendor_short_name'],
        'user_profile_id':this.vendorUser[vendor]['user_profile_id'],
        'real_user_profile_id':this.vendorUser[vendor]['real_user_profile_id']
      }
    };

    if(!data['vendor_name'].trim() || !data['vendor_short_name'].trim() || !data['user_profile_id'].trim()){
      Swal('Error...', 'All Fields are required', 'error');
      return;
    }

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 409){
        Swal('Error', 'User Id Already Exist', 'error');
        return;
      }

      if(response.status == 200){
        this.getVendorList();
        this.vendorUser = [];
        this.vendorEdit = [];
        Swal('Success', 'Vendor Updated Successfully', 'success');
      }else{
        Swal('Oops...', 'Something went wrong!', 'error');
      }
    });

  }

  getOfficerList(){

    this.route  = 'get-officer-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.officerList = response.data;
      }
    });
  }

  generateVendorApiKey(vendorDetail){

    Swal({
      title: "Are you sure?",
      text: "It will delete previous API key and you will not be able to recover it!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.route  = 'generate-new-vendor-api-key';
        const token = localStorage.getItem('userToken');
        let data = {'vendor_id':vendorDetail['id'], 'vendor_name':vendorDetail['vendor_name']};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            this.newApiKey = response.api;
            Swal('Success', 'New API Key: <br/> <strong style="color: red;">'+response.api + '</strong>' , 'success');
          }

          if(response.status == 400){
            this.newApiKey = '';
            Swal('Error', 'Something went wrong', 'error');
          }
        });

      }else{

      }

    });

  }

  generateNewPassword(vendorDetail){

    Swal({
      title: "Are you sure?",
      text: "It will delete previous password and you will not be able to recover it!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.route  = 'generate-new-vendor-login-password';
        const token = localStorage.getItem('userToken');
        let data = {'vendor_id':vendorDetail['id']};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204) {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            this.newApiKey = response.password;
            Swal('Success', 'New login password: <br/> <strong style="color: green;">'+response.password + '</strong>' , 'success');
          }

          if(response.status == 400){
            this.newApiKey = '';
            Swal('Error', 'Something went wrong', 'error');
          }
        });

      }else{

      }

    });

  }

  saveOfficeName(){

    this.errorOfficeName = false;

    if(this.officeName.trim()){
      this.formofficeNameError = '';
    }else{
      this.formofficeNameError = 'Please Enter Office Name';
      this.errorOfficeName = true;
    }

    if(!this.errorOfficeName){

      this.route  = 'validate-office-name';
      const token = localStorage.getItem('userToken');
      let data = {'officeName':this.officeName};

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          if(response.data.length){
            this.formofficeNameError = 'Office Name already exist';
            this.errorOfficeName = true;
          }else{
            this.formofficeNameError = '';
            this.addOffice();
          }
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });
    }
  }

  setOfficerTypeView(){
    this.officerView = 'add';
    this.showofficerTypeEdit = [];
    this.officerTypeUpdate = [];
    this.errorOfficerUpdate =false;
    this.officerTypeUpdateError = '';
    this.officerType = '';
    this.officerTypeError = '';
    this.errorOfficer = false;
  }

  deleteOfficerType(officerTypeDetail){

    Swal({
      title: "Are you sure?",
      text: "It will delete all the details related to this officer type and once deleted, you will not be able to recover!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.industryListLoader = true;

        this.route  = 'delete-officer-type';
        const token = localStorage.getItem('userToken');
        let data = {'officer-type-id':officerTypeDetail['id']};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204)
          {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            this.officerView = 'list';
            Swal("Successfully deleted officer type");
            this.getOfficerTypeList();
          }
        });

      }else{
        // swal("Industry deletion ");
      }

    });

  }

  cancleOfficerType(){
    this.errorOfficerUpdate =false;
    this.officerTypeUpdateError = '';
    this.officerView = 'list';
    this.showofficerTypeEdit = [];
    this.officerTypeUpdate = [];
  }

  updateOfficerType(officerTypeid, OfficerTypeDetail){

    this.errorOfficerUpdate = false;

    if(OfficerTypeDetail['officer_type'] && OfficerTypeDetail['officer_type'].trim()){
      this.officerTypeUpdateError = '';
    }else{
      this.officerTypeUpdateError = 'Please Enter Office Type';
      this.errorOfficerUpdate = true;
    }

    if(!this.errorOfficerUpdate){
      this.validateOfficerType(OfficerTypeDetail['officer_type'].trim(), 'edit', officerTypeid);
    }
  }

  saveOfficerType(){

    this.errorOfficer = false;

    if(this.officerType.trim()){
      this.officerTypeError = '';
    }else{
      this.officerTypeError = 'Please Enter Office Name';
      this.errorOfficer = true;
    }

    if(!this.errorOfficer){
      this.validateOfficerType(this.officerType, 'add', null);
    }
  }

  validateOfficerType(officerType,requestType, officerTypeid){
    this.route  = 'validate-officer-type';
    const token = localStorage.getItem('userToken');
    let data = {'officerType':officerType};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        if(response.data.length){

          if(requestType == 'add'){
            this.officerTypeError = 'Officer type already exist';
            this.errorOfficer = true;
          }else{
            this.officerTypeUpdateError = 'Please Enter Office Type';
            this.errorOfficerUpdate = true;
          }

        }else{
          this.officerTypeUpdateError = '';
          this.officerTypeError = '';
          this.addOfficerType(officerType,requestType, officerTypeid);
        }
      }else{
        Swal('Oops...', 'Something went wrong!', 'error');
      }
    });
  }

  attachDistrictGroup(requestFor){

    this.attachError = false;

    if(this.attachOffice){
      this.attachOfficetypeError = '';
    }else{
      this.attachOfficetypeError = 'Please Select Office Type';
      this.attachError = true;
    }

    if(this.attachGroupName){
      this.attachGroupError = '';
    }else{
      this.attachGroupError = 'Please Select Group';
      this.attachError = true;
    }

    if(this.selectedDistrict.length){
      this.attachDistrictError = '';
    }else{
      this.attachDistrictError = 'Please Select District';
      this.attachError = true;
    }

    if(!this.attachError){

      if(requestFor == 'add'){
        this.route  = 'attach-district-group';
      }else{
        this.route  = 'edit-attach-district-group';
      }
      const token = localStorage.getItem('userToken');
      let data = {
                  'officerTypeId':this.attachOffice,
                  'groupId':this.attachGroupName,
                  'district':this.selectedDistrict
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          if(requestFor == 'add') {
            Swal('Success', 'District Attached Successfully', 'success');
          }else{
            Swal('Success', 'District Updated Successfully', 'success');
          }

          this.attachOffice = '';
          this.selectedDistrict = [];
          this.dropdownList = [];
          this.attachGroupList = [];
          this.attachGroupName = '';
          this.attachOfficetypeError = '';
          this.attachError = false;
          this.attachGroupError = '';
          this.attachDistrictError = '';

          this.attachDistrictView = 'list';
          this.getDistrictAttachedList();
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });
    }
  }

  deleteDistrictAttached(attachedDetail){

    this.route  = 'delete-attached-district';
    const token = localStorage.getItem('userToken');

    let data = {'office_type_id': attachedDetail['officeTypeId'], 'group_id': attachedDetail['groupId']};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        Swal('Success', 'District Detached Successfully', 'success');
      }

      if(response.status == 409){
        Swal('Oops...', 'Something went wrong!', 'error');
      }
      this.getDistrictAttachedList();
    });
  }

  editDistrictAttached(attachDetails){
    this.attachDistrictView = 'edit';
    this.resetAttachDistrict();

    this.getDistrictList();
    this.getAttachedDistrict(attachDetails['officeTypeId'], attachDetails['groupId']);

    this.getOfficeTypeList();
    this.attachOffice = attachDetails['officeTypeId'];

    this.getAttachGroupName('attach');
    this.attachGroupName = attachDetails['groupId'];

  }

  getAttachedDistrict(officeTypeId, groupId){
    this.route  = 'get-attached-district';
    const token = localStorage.getItem('userToken');

    let data = {'office_type_id': officeTypeId, 'group_id': groupId};
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.selectedDistrict = response.data;
      }
    });
  }

  cancelDistrictGroup(){
    this.attachDistrictView = 'list';
    this.resetAttachDistrict();
    this.getDistrictList();
  }

  validateRole(){
    this.roleError = false;

    if(this.roleOffice){
      this.roleOfficetypeError = '';
    }else{
      this.roleOfficetypeError = 'Please Select Office Type';
      this.roleError = true;
    }

    if(this.roleGroupName){
      this.roleGroupError = '';
    }else{
      this.roleGroupError = 'Please Select Group';
      this.roleError = true;
    }

    if(this.roleName.trim()){
      this.roleNameError = '';
    }else{
      this.roleNameError = 'Please Enter Role Name';
      this.roleError = true;
    }

    if(this.description.trim()){
      this.descriptionError = '';
    }else{
      this.descriptionError = 'Please Enter Description';
      this.roleError = true;
    }

    if(this.scrutinyRight.trim()){
      this.scrutinyRightError = '';
    }else{
      this.scrutinyRightError = 'Please Select Scrutiny Right';
      this.roleError = true;
    }

    if(this.canInspection.trim()){
      this.canInspectionError = '';
    }else{
      this.canInspectionError = 'Please Select Inspection Right';
      this.roleError = true;
    }

    if(this.grantRegular.trim()){
      this.grantRegularError = '';
    }else{
      this.grantRegularError = 'Please Select Grant Regular';
      this.roleError = true;
    }

    if(this.grantTrial.trim()){
      this.grantTrialError = '';
    }else{
      this.grantTrialError = 'Please Select Grant Trail';
      this.roleError = true;
    }

    if(this.returnRight.trim()){
      this.returnRightError = '';
    }else{
      this.returnRightError = 'Please Select Return Right';
      this.roleError = true;
    }

    if(this.roleOfficerType){
      this.roleOfficerTypeError = '';
    }else{
      this.roleOfficerTypeError = 'Please Select Officer Type';
      this.roleError = true;
    }

    if(this.roleLinkOfficer){
      this.roleLinkOfficerError = '';
    }else{
      this.roleLinkOfficerError = 'Please Select Link Officer';
      this.roleError = true;
    }

    if(this.roleStatus.trim()){
      this.roleStatusError = '';
    }else{
      this.roleStatusError = 'Please Select Status';
      this.roleError = true;
    }


    if(this.roleSubRegionList.length){
      this.roleSubRegionError = '';
    }else{
      this.roleSubRegionError = 'Please Select Sub Region';
      this.roleError = true;
    }
  }

  addRole(requestType){

    this.validateRole();

    if(!this.roleError){

      if(requestType == 'add'){
        this.roleId = null;
        this.route  = 'add-role';
      }else{
        this.route  = 'update-role';
      }

      const token = localStorage.getItem('userToken');
      let data = {
                  'officeTypeId':this.roleOffice,
                  'groupId':this.roleGroupName,
                  'roleName':this.roleName,
                  'officerTypeId':this.roleOfficerType,
                  'roleLinkOfficerId':this.roleLinkOfficer,
                  'roleStatus':this.roleStatus,
                  'subRegionId':this.roleSubRegionList,
                  'role_id' : this.roleId,

                  'description' : this.description,
                  'scrutinyRight' : this.scrutinyRight,
                  'returnRight' : this.returnRight,
                  'grantTrial' : this.grantTrial,
                  'grantRegular' : this.grantRegular,
                  'assignedDays' : this.assignedDays,
                  'canInspection' : this.canInspection
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          if(requestType == 'add'){
            Swal('Success', 'Role Added Successfully', 'success');
          }else{
            Swal('Success', 'Role Updated Successfully', 'success');
          }

          this.resetRoleForm();
          this.roleView = 'list';
          this.getRoleList();

        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });
    }
  }

  resetRoleForm(){
    this.roleOffice = '';
    this.roleOfficetypeError = '';
    this.roleGroupName = '';
    this.roleGroupError = '';
    this.roleName = '';
    this.roleNameError = '';
    this.roleOfficerType = '';
    this.roleOfficerTypeError = '';
    this.roleLinkOfficer = '';
    this.roleLinkOfficerError = '';
    this.roleStatus = '';
    this.roleStatusError = '';
    this.roleSubRegion = '';
    this.roleSubRegionError = '';
    this.roleError = false;
    this.subRegionList = [];
    this.roleSubRegionList = [];
    this.attachGroupList = [];

    this.description = '';
    this.descriptionError = '';
    this.scrutinyRight = 'yes';
    this.scrutinyRightError = '';
    this.returnRight = 'yes';
    this.returnRightError = '';
    this.grantTrial = 'yes';
    this.grantTrialError = '';
    this.grantRegular = 'yes';
    this.grantRegularError = '';
    this.assignedDays = 1;
    this.assignedDaysError = '';
    this.canInspection = 'no';
    this.canInspectionError = '';
  }

  addOffice(){
    this.route  = 'add-office';
    const token = localStorage.getItem('userToken');
    let data = {
      'officeName':this.officeName
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){

        this.officeName = '';
        this.errorOfficeName = false;
        this.formofficeNameError = '';

        Swal('Success', 'Office Added Successfully', 'success');
        this.getOfficeList();
        this.officeAdminView = 'list';
      }else{
        Swal('Oops...', 'Something went wrong!', 'error');
      }
    });
  }

  addOfficerType(officerType, requestType, officerTypeid){

    this.route  = 'add-officer-type';
    const token = localStorage.getItem('userToken');
    let data = {
      'officerType':officerType,
      'requestType':requestType,
      'officerTypeid' : officerTypeid
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){

        this.officerType = '';
        this.officerTypeError = '';
        this.officerTypeUpdateError = '';
        this.errorOfficer = false;
        this.errorOfficerUpdate = false;

        if(requestType == 'add'){
          Swal('Success', 'Officer Type Added Successfully', 'success');
        }else{
          Swal('Success', 'Officer Type Updated Successfully', 'success');
        }

        this.officerView = 'list';
        this.getOfficerTypeList();
        this.showofficerTypeEdit = [];
        this.officerTypeUpdate = [];

      }else{
        Swal('Oops...', 'Something went wrong!', 'error');
      }
    });
  }

  getDisabledIndustryList(){

    this.industryListLoader = true;
    this.route  = 'get-all-disabled-industries';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      this.industryListLoader = false;
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      let index = 0;
      if(response.status == 200){
        this.allIndustriesDetails = response.data;

        for (var parameterKey in response.data) {
          this.searchField[response.data[parameterKey]['id']] = [];
          this.searchField[response.data[parameterKey]['id']]['industryType'] = response.data[parameterKey]['industry_type'];
          this.searchField[response.data[parameterKey]['id']]['ocmmsId'] = '';
          this.searchField[response.data[parameterKey]['id']]['category'] = '';
          this.searchField[response.data[parameterKey]['id']]['officer'] = '';
        }
      }
    });

  }

  switchView(type){
    this.showIndustryList = type;
    this.showOfficeEdit = [];

    if(type == 'indList'){
      this.headingTitle = 'Industry Detail Management';
      this.getDisabledIndustryList();
      this.getOfficerList();
    }else if(type == 'officer'){
      this.headingTitle = 'Officer';

      this.userDetails['name'] = '';
      this.userDetails['email'] = '';
      this.userDetails['contact'] = '';
      this.userDetails['region'] = '';

      this.formErrorName = '';
      this.formErrorEmail = '';
      this.formErrorContact = '';
      this.formErrorRegion = '';
      this.error = false;
    }else if(type == 'officerList'){
      this.headingTitle = 'Officer List';
      this.userToUpdate = [];
      this.showEdit = [];
      this.getOfficerList();
    }else if(type == 'officeAdmin'){
      this.officeName = '';
      this.errorOfficeName = false;
      this.formofficeNameError = '';
      this.getOfficeList();
      this.headingTitle = 'Office Administration';
    }else if(type == 'officeType'){
      this.officeTypeView = 'list';
      this.getOfficeList();
      this.getOfficeTypeOfficeWise();

      this.officeTypeInput[this.officeTypeCount] = true;
      this.headingTitle = 'Office Type Administration';
    }else if(type == 'district'){
      this.districtInternalView = 'list';
      this.getOfficeList();
      this.getDistrictList();

      this.officeTypeInput[this.officeTypeCount] = true;
      this.headingTitle = 'District Administration';
    }else if(type == 'tehsil'){

      this.tehsilInternalView = 'list';
      this.getDistrictList();
      this.getTehsilList();
      this.officeTypeInput[this.officeTypeCount] = true;
      this.headingTitle = 'Tehsil Administration';
    }else if(type == 'group'){

      this.groupView = 'list';

      this.getGroupList();
      this.getOfficeTypeList();
      this.groupInput[this.groupCount] = true;
      this.headingTitle = 'Groups';

    }else if(type == 'subRegion'){

      this.gerSubRegionList();
      this.subRegionView= 'list';
      this.getOfficeTypeList();
      this.subRegionInput[this.subRegionCount] = true;
      this.headingTitle = 'Sub Region';
    }else if(type == 'officerType'){
      this.officerView = 'list';
      this.getOfficerTypeList();
      this.headingTitle = 'Type of Officer';
    }else if(type == 'attachDistrict'){

      this.attachDistrictView = 'list';
      this.getDistrictAttachedList();

      this.headingTitle = 'Attach District in Group';
    }else if(type == 'role'){
      this.headingTitle = 'Role Management';
      this.roleView = 'list';
      this.getRoleList();
    }else if(type == 'vendorManagement'){
      this.getVendorList();
      this.vendorUser = [];
      this.vendorEdit = [];
      this.headingTitle = 'Vendor Management';
    }
  }

  getDistrictAttachedList(){
    this.attachDistrictLoader = true;
    this.route  = 'get-attach-district-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      this.attachDistrictLoader = false;
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.attachDistrictList = response.data;
      }
    });
  }

  getVendorList(){

    this.vendorListLoader = true;
    this.route  = 'get-vendor-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      this.vendorListLoader = false;
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.vendorList = response.data;
        console.log(this.vendorList);
      }
    });
  }

  CancelRoleEdit(){
    this.roleView = 'list';
    this.resetRoleForm();
    this.getRoleList();
  }



  editRole(roleDetail){

    this.setRoleView('edit');
    this.roleView = 'edit';

    console.log(roleDetail);
    this.getSubRegionListRoleWise(roleDetail['id']);
    this.roleId = roleDetail['id'];

    this.roleOffice = roleDetail['officeTypeId'];

    this.getAttachGroupName('role');
    this.roleGroupName = roleDetail['groupId'];
    this.getSubRegionList();
    this.roleName = roleDetail['role_name'];
    this.roleOfficerType = roleDetail['officerTypeId'];
    this.roleLinkOfficer = roleDetail['ocmms_officer_id'];
    this.roleStatus = roleDetail['role_status'];

    this.description = roleDetail['description'];
   this.scrutinyRight = roleDetail['scrutiny_right'];
   this.returnRight = roleDetail['return_right'];
   this.grantTrial = roleDetail['grant_trial'];
   this.grantRegular = roleDetail['grant_regular'];
   this.assignedDays = roleDetail['assigned_days'];
   this.canInspection = roleDetail['can_inspection'];

  }

  getRoleList(){

    this.roleListLoader = true;
    this.route  = 'get-role-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      this.roleListLoader = false;
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.roleList = response.data;
        this.roleOfficerOcmmsList = response.ocmms_officer_list;
      }
    });
  }

  gerSubRegionList(){

    this.subRegionLoader = true;
    this.route  = 'get-sub-region-list-admin';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {
      this.subRegionLoader = false;
      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.subRegionListAdmin = response.data;
      }
    });
  }

  gerOcemmsOfficerList(){

    this.route  = 'get-ocemms-officer-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.roleOfficerList = response.data;

      }
    });

  }

  getGroupName(){
    this.route  = 'get-group-list';
    const token = localStorage.getItem('userToken');
    let data = {'office-type-id':this.subRegionOffice};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.subRegionGroupList = response.data;
      }
    });
  }

  cancelUpdateOffice(){
    this.showOfficeEdit = [];
    this.formEditDistrictNameError = '';
    this.formEditDistrictCodeError = '';
    this.errorEditDistrict = false;
  }

  ValidateUpdateOffice(office, officeEdit, type){

    this.formEditDistrictNameError = '';
    this.formEditDistrictCodeError = '';
    this.errorEditDistrict = false;

    if(type == 'edit'){
      if(officeEdit['office_'+office['id']]['office_name'].trim()){
        this.formEditOfficeNameError = '';
      }else{
        this.formEditOfficeNameError = 'Please Enter Office Name';
        this.errorEditOfficeName = true;
      }
    }

    if(!this.errorEditOfficeName){

      this.route  = 'validate-office-name';
      const token = localStorage.getItem('userToken');
      let data = {'officeName':officeEdit['office_'+office['id']]['office_name'].trim()};

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          if(response.data.length){
            this.formEditOfficeNameError = 'Office Name already exist';
            this.errorEditOfficeName = true;
          }else{
            this.formEditOfficeNameError = '';
            this.updateOfficeName(office,officeEdit,type);
          }
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }
      });
    }
  }

  ValidateUpdateDistrict(district,showDistrictEdit, type){

    this.errorEditDistrict= false;

    if(type == 'edit'){
      if(showDistrictEdit['district_'+district['id']]['district_name'].trim()){
        this.formEditDistrictNameError = '';
      }else{
        this.formEditDistrictNameError = 'Please Enter District Name';
        this.errorEditDistrict = true;
      }

      if(showDistrictEdit['district_'+district['id']]['district_code'].trim()){
        this.formEditDistrictCodeError = '';
      }else{
        this.formEditDistrictCodeError = 'Please Enter District Code';
        this.errorEditDistrict = true;
      }
    }

    if(!this.errorEditDistrict){
      this.updateDistrict(district,showDistrictEdit,type);
    }
  }

  updateDistrict(district,showDistrictEdit,type){
    this.route  = 'update-district';
    const token = localStorage.getItem('userToken');

    let data = {
      'district_id': district?district['id']:null,
      'type':type,
      'district_name': (showDistrictEdit && showDistrictEdit['district_'+district['id']] && showDistrictEdit['district_'+district['id']]['district_name'])?(showDistrictEdit['district_'+district['id']]['district_name']) :'',
      'district_code': (showDistrictEdit && showDistrictEdit['district_'+district['id']] && showDistrictEdit['district_'+district['id']]['district_code'])?(showDistrictEdit['district_'+district['id']]['district_code']) :''
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        if(type == 'edit'){
          Swal('Success', 'District Updated Successfully', 'success');
        }else{
          Swal('Success', 'District Deleted Successfully', 'success');
        }
        this.getDistrictList();
        this.showDistrictEdit = [];
      }
      if(response.status == 409){
        Swal('Oops...', 'Something went wrong!', 'error');
        this.getDistrictList();
        this.showDistrictEdit = [];
      }
    });
  }

  updateOfficeType(officeType, showOfficeTypeEdit, type){
    this.route  = 'update-office-type';
    const token = localStorage.getItem('userToken');

    let data = {'office-type-id': officeType?officeType['id']:null, 'type':type, 'office-type': (showOfficeTypeEdit && showOfficeTypeEdit['office_'+officeType['id']] && showOfficeTypeEdit['office_'+officeType['id']]['office_name'])?(showOfficeTypeEdit['office_'+officeType['id']]['office_name']) :'' };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        if(type == 'edit'){
          Swal('Success', 'Office Type Updated Successfully', 'success');
        }else{
          Swal('Success', 'Office Type Deleted Successfully', 'success');
        }
        this.getOfficeTypeOfficeWise();
        this.showOfficeTypeEdit = [];
      }
      if(response.status == 409){
        Swal('Oops...', 'Something went wrong!', 'error');
        this.getOfficeTypeOfficeWise();
        this.showOfficeTypeEdit = [];
      }
    });
  }

  updateOfficeName(office,officeEdit,type){

    this.route  = 'update-office-name';
    const token = localStorage.getItem('userToken');

    let data = {'office-id': office?office['id']:null, 'type':type, 'office-name': (officeEdit && officeEdit['office_'+office['id']] && officeEdit['office_'+office['id']]['office_name'])?(officeEdit['office_'+office['id']]['office_name']) :'' };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.getOfficeList();

        if(type == 'edit'){
          Swal('Success', 'Office Name Updated Successfully', 'success');
        }else{
          Swal('Success', 'Officer Name Deleted Successfully', 'success');
        }
        this.showOfficeEdit = [];
      }

      if(response.status == 409){
        Swal('Oops...', 'Something went wrong!', 'error');
        this.getOfficeList();
        this.showOfficeEdit = [];
      }
    });
  }

  deleteRole(roleId){

    this.route  = 'delete-role';
    const token = localStorage.getItem('userToken');

    let data = {'role_id': roleId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
          this.getRoleList();
          Swal('Success', 'Role Deleted Successfully', 'success');
      }

      if(response.status == 409){
        Swal('Oops...', 'Something went wrong!', 'error');
        this.getRoleList();
      }
    });
  }

  getAttachGroupName(groupFor){
    this.roleGroupName = '';
    this.attachGroupName = '';
    this.subRegionList = [];
    this.roleSubRegionList = [];
    this.route  = 'get-group-list';
    const token = localStorage.getItem('userToken');

    let data = {};

    if(groupFor == 'attach'){
      data = {'office-type-id':this.attachOffice};
    }
    if(groupFor == 'role'){
      data = {'office-type-id':this.roleOffice};
    }

    if( ( groupFor == 'attach' && this.attachOffice ) || (groupFor == 'role' && this.roleOffice ) ){
      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          this.attachGroupList = response.data;
        }
      });
    }else{
      this.attachGroupList = [];
    }

  }

  getSubRegionList(){

    this.subRegionList = [];
    this.roleSubRegionList = [];

    this.route  = 'get-sub-region-list';
    const token = localStorage.getItem('userToken');
    let data = {'office-type-id':this.roleOffice, 'group-id':this.roleGroupName};

    if(this.roleOffice && this.roleGroupName){
      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          this.subRegionList = response.data;
        }
      });
    }else{
      this.subRegionList = [];
    }

  }

  getSubRegionListRoleWise(roleId){
    this.route  = 'get-sub-region-list-role-wise';
    const token = localStorage.getItem('userToken');
    let data = {'role_id':roleId};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.roleSubRegionList =  response.data;
        // this.subRegionList = response.data;
      }
    });
  }

  validateUser(){

    this.error = false;

    if(this.userDetails['name'] && this.userDetails['name'] != '' && this.userDetails['name'] != ' '){
      this.formErrorName = '';
    }else{
      this.formErrorName = 'Please Enter Name';
      this.error = true;
    }

    if(this.userDetails['email'] && this.userDetails['email'] != '' && this.userDetails['email'] != ' '){
      this.formErrorEmail = '';
    }else{
      this.formErrorEmail = 'Please Enter Email';
      this.error = true;
    }

    if(this.userDetails['contact'] && this.userDetails['contact'] != '' && this.userDetails['contact'] != ' '){

      if(this.userDetails['contact'].length < 10){
        this.formErrorContact = 'Number should be min of 10 digit';
        this.error = true;
      }else{
        this.formErrorContact = '';
      }

    }else{
      this.formErrorContact = 'Please Enter Contact';
      this.error = true;
    }

    if(this.userDetails['region'] && this.userDetails['region'] != '' && this.userDetails['region'] != ' '){
      this.formErrorRegion = '';
    }else{
      this.formErrorRegion = 'Please Enter Region';
      this.error = true;
    }

    if(!this.error){

      this.route  = 'validate-email';
      const token = localStorage.getItem('userToken');
      let data = {'email':this.userDetails['email']};

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          if(response.data.length){
            this.formErrorEmail = 'Email id already exist';
            this.error = true;
          }else{
            this.formErrorEmail = '';
            this.addOfficer();
          }
        }
      });

    }

  }

  getOfficeList(){
    this.route  = 'get-office-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this.officeListLoader = true;

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.officeList = response.data;
      }

      this.officeListLoader = false;
    });
  }

  getOfficeType(){
    this.route  = 'get-office-type-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this.officeListLoader = true;

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.officeList = response.data;
      }

      this.officeListLoader = false;
    });
  }

  getOfficeTypeOfficeWise(){

    this.route  = 'get-office-type-list-office-wise';
    const token = localStorage.getItem('userToken');
    let data = {};

    this.officeListViewLoader = true;

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.officeListView = response.data;
      }

      this.officeListViewLoader = false;
    });
  }

  getDistrictList(){
    this.route  = 'get-district-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this.districtLoader = true;

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.districtList = response.data;
        this.dropdownList = response.data;
        this.districtLoader = false;
      }
    });
  }

  getTehsilList(){
    this.route  = 'get-tehsil-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this.tehsilLoader = true;

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.tehsilList = response.data;
        this.tehsilLoader = false;
      }
    });
  }

  getGroupList(){
    this.route  = 'get-group-list-admin';
    const token = localStorage.getItem('userToken');
    let data = {};

    this.groupLoader = true;

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.groupList = response.data;
        this.groupLoader = false;
      }
    });
  }

  getOfficerTypeList(){
    this.route  = 'get-officer-type-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this.officerTypeListLoader = true;
    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.officerTypeList = response.data;
      }
      this.officerTypeListLoader = false;
    });
  }

  getOfficeTypeList(){
    this.route  = 'get-office-type-list';
    const token = localStorage.getItem('userToken');
    let data = {};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        this.officeTypeList = response.data;
      }
    });
  }

  addOfficer(){
    this.route  = 'add-spcb-officer';
    const token = localStorage.getItem('userToken');
    let data = {
      'name':this.userDetails['name'],
      'email':this.userDetails['email'],
      'contact':this.userDetails['contact'],
      'region':this.userDetails['region']
    };

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }
      if(response.status == 200){
        if(response.data){
          this.userDetails['name'] = '';
          this.userDetails['email'] = '';
          this.userDetails['contact'] = '';
          this.userDetails['region'] = '';
          Swal('Success', 'Officer Added Successfully', 'success');
        }else{
          Swal('Oops...', 'Something went wrong!', 'error');
        }

      }else{
        Swal('Oops...', 'Something went wrong!', 'error');
      }
    });
  }

  deleteIndustry(industryId){

    Swal({
      title: "Are you sure?",
      text: "It will delete all the details related to this industry and once deleted, you will not be able to recover!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.industryListLoader = true;

        this.route  = 'delete-industry';
        const token = localStorage.getItem('userToken');
        let data = {'industry_id':industryId};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204)

          {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            Swal("Successfully deleted industry details");
            this.getDisabledIndustryList();
          }
        });

      }else{
        // swal("Industry deletion ");
      }

    });

  }

  deleteGroup(group){

    Swal({
      title: "Are you sure?",
      text: "It will delete all the details related to this group and once deleted, you will not be able to recover!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.industryListLoader = true;

        this.route  = 'delete-group';
        const token = localStorage.getItem('userToken');
        let data = {'office_type_id':group['office_type_id']};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204)

          {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            Swal("Successfully deleted group details");
            this.getGroupList();
          }
        });

      }else{
        // swal("Industry deletion ");
      }

    });

  }

  deleteSubRegion(subRegionDetail){

    Swal({
      title: "Are you sure?",
      text: "It will delete all the details related to this sub-region and once deleted, you will not be able to recover!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.industryListLoader = true;

        this.route  = 'delete-sub-region';
        const token = localStorage.getItem('userToken');
        let data = {
          'office-type-id': subRegionDetail['office_type_id'],
          'group-id': subRegionDetail['group_id']
        };

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204)

          {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            Swal("Successfully deleted group details");
            this.gerSubRegionList();
          }
        });

      }else{
        // swal("Industry deletion ");
      }

    });

  }

  deleteTehsil(tehsil){

    Swal({
      title: "Are you sure?",
      text: "It will delete all the details related to this tehsil and once deleted, you will not be able to recover!",
      type: 'warning',
      showConfirmButton: true,
      showCancelButton: true
    }).then((willDelete) => {

      if(willDelete.value){

        this.industryListLoader = true;

        this.route  = 'delete-tehsil';
        const token = localStorage.getItem('userToken');
        let data = {'district_id':tehsil['district_id']};

        this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

          if(response.status == 204)

          {
            localStorage.removeItem('userToken');
            localStorage.removeItem('userData');
            this.router.navigate(['login']);
          }

          if(response.status == 200){
            Swal("Successfully deleted tehsil details");
            this.getTehsilList();
          }
        });

      }else{
        // swal("Industry deletion ");
      }

    });

  }

  saveIndustryDetails(indusryId){

    if(this.searchField[indusryId]['category'].trim() && this.searchField[indusryId]['category'].trim() != ' ' && this.searchField[indusryId]['ocmmsId'].trim() && this.searchField[indusryId]['ocmmsId'].trim() != ' ' && this.searchField[indusryId]['officer'].trim() && this.searchField[indusryId]['officer'].trim() != ' '){

      this.industryListLoader = true;
      this.route  = 'update-industry-details';
      const token = localStorage.getItem('userToken');
      let data = {
        'category':this.searchField[indusryId]['category'],
        'ocmmsId':this.searchField[indusryId]['ocmmsId'],
        'officer':this.searchField[indusryId]['officer'],
        'industryType':this.searchField[indusryId]['industryType'],
        'indusryId':indusryId,
      };

      this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

        if(response.status == 204) {
          localStorage.removeItem('userToken');
          localStorage.removeItem('userData');
          this.router.navigate(['login']);
        }
        if(response.status == 200){
          this.getDisabledIndustryList();
        }
      });
    }else{
      Swal('Error', 'Please provide complete details!', 'error');
    }

  }
}
